import { createSelector } from 'reselect';

export const homePageSelector = createSelector(
  (state) => state.home,
  (home) => home
);

export const homeSelector = createSelector(homePageSelector, (home) => home.videoLists);
